export default "__VITE_ASSET__wAJltgZj__"